import { useEffect, useState } from "react";
import { getBeneficiaries } from "../../../../Properties/AddProperty/ducks/actions/getOwner";
import { type DepositDestinationOption, mapBeneficiaryApiToDepositOptions } from "../depositDestinationOptions";

export function useBeneficiaryDepositOptions(ownerId: string | undefined | null) {
  const [options, setOptions] = useState<DepositDestinationOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!ownerId) {
      setOptions([]);
      return;
    }
    
    setLoading(true);
    getBeneficiaries(ownerId)
      .then((data) => {
        if (cancelled) return;
        const rows = Array.isArray(data) ? data : [];
        setOptions(mapBeneficiaryApiToDepositOptions(rows));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [ownerId]);

  return { beneficiaryDepositOptions: options, beneficiaryOptionsLoading: loading };
}
